export default __webpack_public_path__ + "5823b07bd09d4d5666643b6c4849aa01.svg";